export enum TableId {
  Users = 1, // Пользователи
  UsersGroups = 2, // Группы пользователей
  Access = 3, // Доступ
  Persons = 4, // Представители
  LegalUsers = 5, // юридические лица
  Counterparties = 6, // Контрагенты
  EventTypes = 7, // События аудита
  GuiElementsTypes = 8, // Элементы интерфейса
  UserRoles = 9, // Роли
  Comments = 11, // Комментарии
  Regions = 15, // Регионы
  Segments = 16, // Сегменты
  Address = 18, // Адреса
  Contacts = 19, // Контакты
  SystemParams = 26, // Системные параметры
  files = 28, // Файлы
  Accounts = 30, // Расчетные счета
  Banks = 31, // Банки
  Representatives = 37, // Представители
  LegalForms = 38, // Организационно-правовые формы
  Actions = 39, // Действия скриптов
  Conditions = 40, // Условия скриптов
  ScriptModels = 41, // Модели скриптов
  Scripts = 42, // Скрипты
  ErrorDescriptions = 43, // Описания ошибок
  DocumentTypes = 44, // Типы документов
  Prints = 45, // Распечатки
  DocumentParents = 46, // Родители документов
  Servers = 47, // Сервера
  Positions = 48, // Должности
  Projects = 49, // Проекты
  Calendar = 50, // Календарь
  Codes = 53, // Штрих-коды
  CodeParents = 54, // Ассоциация штрих-кодов
  Documents = 55, // Документы
  RoutePoints = 56, // Точки маршрутов
  DocumentLinks = 57, // Связи документов
  DocumentChrono = 58, // Хронология
  ResponsibleDummies = 59, // Заглушки исполнителей
  Dashboards = 60, // Приборки
  Indexes = 67, // Индексы
  Favorites = 68, // Избранное
  LinkTypes = 69, // Типы ссылок
  ObjectViews = 70, // Просмотры
}
